export const DISPLAY_STATE_ACTION = "DISPLAY_STATE_ACTION";
export const ADD_UPLOADS_ACTION = "ADD_UPLOADS_ACTION";
export const REMOVE_UPLOAD_ACTION = "REMOVE_UPLOAD_ACTION";
export const SET_SELECTED_ACTION = "SET_SELECTED_ACTION";
export const SET_CROP_ACTION = "SET_CROP_ACTION";
export const SET_COMPLETED_CROP_ACTION = "SET_COMPLETED_CROP_ACTION";
export const SET_NEW_IMAGE_ACTION = "SET_NEW_IMAGE_ACTION";
export const RESET_NEW_IMAGE_ACTION = "RESET_NEW_IMAGE_ACTION";
